import React from 'react';
import { StarIcon } from 'lucide-react';
type StarRatingProps = {
  size?: 'sm' | 'md';
};
export function StarRating({
  size = 'md'
}: StarRatingProps) {
  const iconSize = size === 'sm' ? 'h-3.5 w-3.5' : 'h-5 w-5';
  return <span className="flex gap-0.5" role="img" aria-label="5 out of 5 stars" data-id="element-308" data-mp="3kb7trw0u0o9k">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className={`${iconSize} fill-accent text-accent`} aria-hidden="true" data-id="element-309" data-mp="3p4txuzsxjjtr" />)}
    </span>;
}